(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carrinho"] && !Shopify.designMode) return;
  try {
    ;(function () {
    var drawer = document.querySelector('[data-carrinho-drawer]')
    if (!drawer) return
    var itens = drawer.querySelector('[data-carrinho-itens]')
    var footer = drawer.querySelector('[data-carrinho-footer]')
    var subtotal = drawer.querySelector('[data-carrinho-subtotal]')
    var tituloCount = drawer.querySelector('[data-carrinho-titulo-count]')
    var ultimoCarrinho = null

    function dinheiro(centavos) {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(centavos)
      return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',')
    }

    function esc(valor) {
      return String(valor == null ? '' : valor).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
      })
    }

    function carregarCarrinho() {
      fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json()
        })
        .then(function (cart) {
          ultimoCarrinho = cart
          document.dispatchEvent(new CustomEvent('carrinho:atualizado', { detail: cart }))
          var qtd = cart.item_count
          var countEl = document.querySelector('[data-carrinho-count]')
          if (countEl) {
            countEl.textContent = qtd
            countEl.setAttribute('data-count', qtd)
          }
          if (tituloCount) {
            tituloCount.textContent = qtd
            tituloCount.hidden = qtd === 0
          }
          if (drawer.classList.contains('ativo') && qtd > 0 && window.PetZemTrack) {
            var itensTrack = cart.items.map(function (i) {
              return {
                item_id: i.variant_id,
                item_name: i.product_title,
                item_variant: i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : undefined,
                price: i.price / 100,
                quantity: i.quantity
              }
            })
            PetZemTrack.event('view_cart', {
              currency: cart.currency || 'BRL',
              value: cart.total_price / 100,
              items: itensTrack
            })
          }
          if (!drawer.classList.contains('ativo')) return
          if (qtd === 0) {
            itens.innerHTML = '<p class="carrinho-drawer__vazio"><svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' + drawer.getAttribute('data-texto-vazio') + '</p>'
            footer.hidden = true
            return
          }
          itens.innerHTML = cart.items
            .map(function (item, i) {
              var img = item.image ? '<div class="carrinho-drawer__item-img-wrapper"><img src="' + esc(item.image) + '" alt="" class="carrinho-drawer__item-img" loading="lazy"></div>' : ''
              var url = item.url || '/products/' + item.handle
              return '<div class="carrinho-drawer__item" data-key="' + item.key + '" style="animation-delay:' + i * 0.06 + 's">' + img + '<div class="carrinho-drawer__item-info">' + '<a href="' + esc(url) + '" class="carrinho-drawer__item-nome">' + esc(item.product_title) + '</a>' + (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="carrinho-drawer__item-variante">' + esc(item.variant_title) + '</p>' : '') + '<div class="carrinho-drawer__item-preco">' + dinheiro(item.line_price) + '</div>' + '<div class="carrinho-drawer__item-acoes">' + '<div class="carrinho-drawer__item-qtd">' + '<button class="carrinho-drawer__item-qtd-btn" data-qtd-menos>&minus;</button>' + '<span class="carrinho-drawer__item-qtd-valor" data-qtd-valor>' + item.quantity + '</span>' + '<button class="carrinho-drawer__item-qtd-btn" data-qtd-mais>+</button>' + '</div>' + '<button class="carrinho-drawer__item-remover" data-remover>' + drawer.getAttribute('data-texto-remover') + '</button>' + '</div></div></div>'
            })
            .join('')
          subtotal.textContent = dinheiro(cart.total_price)
          footer.hidden = false
        })
        .catch(function () {})
    }

    function abrirDrawer() {
      if (drawer.classList.contains('ativo')) return
      drawer.classList.add('ativo')
      drawer.setAttribute('aria-hidden', 'false')
      document.body.style.overflow = 'hidden'
      carregarCarrinho()
    }

    function fecharDrawer() {
      drawer.classList.remove('ativo')
      drawer.setAttribute('aria-hidden', 'true')
      document.body.style.overflow = ''
    }

    // API global reusada pela página de produto e pela página de carrinho
    window.PetZemCarrinho = {
      abrir: abrirDrawer,
      fechar: fecharDrawer,
      atualizar: carregarCarrinho,
      adicionar: function (id, quantity) {
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: quantity || 1 })
        })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (err) {
                throw err
              })
            }
            return r.json()
          })
          .then(function (res) {
            if (window.PetZemTrack && res) {
              var precoUni = (res.price || 0) / 100
              PetZemTrack.event('add_to_cart', {
                currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL',
                value: precoUni * (res.quantity || 1),
                items: [{
                  item_id: res.variant_id,
                  item_name: res.product_title,
                  item_variant: res.variant_title && res.variant_title !== 'Default Title' ? res.variant_title : undefined,
                  price: precoUni,
                  quantity: res.quantity || 1
                }]
              })
            }
            document.dispatchEvent(new CustomEvent('cart:added'))
            abrirDrawer()
            return res
          })
      }
    }

    // Botão "Adicionar" nos cards de produto (delegação global)
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-card-add]')
      if (!add) return
      e.preventDefault()
      var id = add.getAttribute('data-card-add')
      if (!id || !window.PetZemCarrinho) return
      add.classList.add('carregando')
      add.disabled = true
      PetZemCarrinho.adicionar(id, 1)
        .then(function () {
          add.classList.remove('carregando')
          add.disabled = false
        })
        .catch(function () {
          add.classList.remove('carregando')
          add.disabled = false
        })
    })

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-carrinho-toggle]')
      if (toggle) {
        e.preventDefault()
        drawer.classList.toggle('ativo')
        drawer.setAttribute('aria-hidden', drawer.classList.contains('ativo') ? 'false' : 'true')
        document.body.style.overflow = drawer.classList.contains('ativo') ? 'hidden' : ''
        if (drawer.classList.contains('ativo')) carregarCarrinho()
      }
      if (e.target.closest('[data-carrinho-fechar]')) {
        drawer.classList.remove('ativo')
        drawer.setAttribute('aria-hidden', 'true')
        document.body.style.overflow = ''
      }
    })

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-carrinho-fechar]') || (e.target.closest('[data-carrinho-drawer]') && !e.target.closest('[data-carrinho-drawer] .carrinho-drawer__painel'))) {
        drawer.classList.remove('ativo')
        drawer.setAttribute('aria-hidden', 'true')
        document.body.style.overflow = ''
      }
    })

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('ativo')) {
        drawer.classList.remove('ativo')
        drawer.setAttribute('aria-hidden', 'true')
        document.body.style.overflow = ''
      }
    })

    var checkoutBtnDrawer = drawer.querySelector('.carrinho-drawer__checkout')
    if (checkoutBtnDrawer) {
      checkoutBtnDrawer.addEventListener('click', function () {
        if (!window.PetZemTrack || !ultimoCarrinho || !ultimoCarrinho.item_count) return
        var cart = ultimoCarrinho
        var itensCheckout = cart.items.map(function (i) {
          return {
            item_id: i.variant_id,
            item_name: i.product_title,
            item_variant: i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : undefined,
            price: i.price / 100,
            quantity: i.quantity
          }
        })
        PetZemTrack.event('begin_checkout', {
          currency: cart.currency || 'BRL',
          value: cart.total_price / 100,
          items: itensCheckout
        })
      })
    }

    document.addEventListener('cart:updated', carregarCarrinho)
    document.addEventListener('cart:added', function () {
      if (drawer.classList.contains('ativo')) carregarCarrinho()
    })

    var carrinhoItens = document.querySelector('[data-carrinho-itens]')
    if (carrinhoItens) {
      carrinhoItens.addEventListener('click', function (e) {
        var item = e.target.closest('[data-key]')
        if (!item) return
        var key = item.getAttribute('data-key')
        if (e.target.closest('[data-remover]')) {
          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          })
            .then(function (r) {
              return r.json()
            })
            .then(function () {
              carregarCarrinho()
            })
            .catch(function () {})
        }
        if (e.target.closest('[data-qtd-mais]')) {
          var qtdEl = item.querySelector('[data-qtd-valor]')
          var qtd = parseInt(qtdEl.textContent, 10) + 1
          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qtd })
          })
            .then(function (r) {
              return r.json()
            })
            .then(function () {
              carregarCarrinho()
            })
            .catch(function () {})
        }
        if (e.target.closest('[data-qtd-menos]')) {
          var qtdEl = item.querySelector('[data-qtd-valor]')
          var qtd = parseInt(qtdEl.textContent, 10) - 1
          if (qtd < 1) qtd = 0
          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qtd })
          })
            .then(function (r) {
              return r.json()
            })
            .then(function () {
              carregarCarrinho()
            })
            .catch(function () {})
        }
      })
    }
  })()
  } catch(e) { console.error(e); }
})();

})();
